export default __webpack_public_path__ + "static/hero2-abc1e502b4cb3fb5b028caab143f8f90.webp";